import { render, staticRenderFns } from "./PerimeterTab.vue?vue&type=template&id=ab4b8dc0"
import script from "./PerimeterTab.vue?vue&type=script&lang=js"
export * from "./PerimeterTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab4b8dc0')) {
      api.createRecord('ab4b8dc0', component.options)
    } else {
      api.reload('ab4b8dc0', component.options)
    }
    module.hot.accept("./PerimeterTab.vue?vue&type=template&id=ab4b8dc0", function () {
      api.rerender('ab4b8dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/rating/partials/tabs/PerimeterTab.vue"
export default component.exports